//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import vClickOutside from 'v-click-outside'
import HeaderMobileList from '~/components/partials/header_mobile_list'
import CoinSearch from '~/components/partials/coin_search'
export default {
  name: 'HeaderMobile',
  directives: {
    clickOutside: vClickOutside.directive
  },
  components: {
    CoinSearch,
    HeaderMobileList
  },
  data () {
    return {
      openSidebar: false,
      showSearch: false
    }
  },
  methods: {
    sidebarToggle () {
      this.openSidebar = !this.openSidebar
      this.$emit('sidebarToggle', this.openSidebar)
    },
    hiddenSearch () {
      this.showSearch = false
    }
  }
}
